import { TextField, Button } from "@mui/material";
import Navbar from "../../components/Navbar";
import Footer from "./sections/Footer";
import { FaEnvelope, FaPhone, FaInstagram } from "react-icons/fa";
import { CONTACT_INFO } from "../../config/contactInfo";

const Contact = () => {
  const contactMethods = [
    {
      title: "ایمیل",
      info: CONTACT_INFO.email,
      href: `mailto:${CONTACT_INFO.email}`,
      icon: <FaEnvelope />,
    },
    {
      title: "تلفن",
      info: CONTACT_INFO.phoneDisplay,
      href: CONTACT_INFO.phoneHref,
      icon: <FaPhone />,
    },
  ];

  return (
    <>
      <Navbar />

      <main className="bg-white text-gray-900">

        {/* Hero */}
        <section className="py-28 bg-gradient-to-b from-secondary_1 via-white to-white border-b">
          <div className="max-w-5xl mx-auto px-6 text-center">
            <span className="inline-block mb-6 px-4 py-1 rounded-full bg-orange-100 text-orange-600 text-sm font-medium">
              ارتباط با بامیزبان
            </span>

            <h1 className="text-4xl md:text-5xl font-extrabold mb-6">
              تماس با ما
            </h1>

            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              اگر سوال، پیشنهاد یا نیاز به راهنمایی دارید،
              تیم بامیزبان همیشه آماده پاسخ‌گویی است.
            </p>
          </div>
        </section>

        {/* Contact Methods */}
        <section className="py-24 bg-gray-50">
          <div className="max-w-4xl mx-auto px-6 grid md:grid-cols-2 gap-8">
            {contactMethods.map((item, i) => (
              <div
                key={i}
                className="bg-white border rounded-3xl p-8
                           hover:shadow-lg transition flex items-center gap-5"
              >
                <div className="w-12 h-12 rounded-xl bg-orange-100 text-orange-500
                                flex items-center justify-center text-xl">
                  {item.icon}
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1">{item.title}</h3>
                  <a href={item.href} dir="ltr" className="text-gray-600 text-sm hover:text-orange-500">
                    {item.info}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Form + Image */}
        <section className="py-24">
          <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">

            {/* Form */}
            <div className="bg-white border rounded-3xl p-10 shadow-sm">
              <h2 className="text-3xl font-bold mb-8">
                فرم ارتباط با ما
              </h2>

              <form className="grid gap-5">
                <TextField label="نام و نام خانوادگی" fullWidth required />
                <TextField label="ایمیل" type="email" fullWidth required />
                <TextField label="موضوع" fullWidth required />
                <TextField
                  label="پیام شما"
                  multiline
                  rows={5}
                  fullWidth
                  required
                />

                <Button
                  type="submit"
                  className="mt-4 px-10 py-4 rounded-2xl
                             bg-orange-500 text-white font-semibold
                             hover:bg-orange-600 shadow-md hover:shadow-lg transition"
                >
                  ارسال پیام
                </Button>
              </form>
            </div>

            {/* Image */}
            <div className="flex justify-center">
              <img
                src="/images/contact/contact.jpg"
                alt="تماس با ما"
                className="rounded-3xl shadow-lg w-full object-cover"
              />
            </div>
          </div>
        </section>

        {/* Working hours */}
        <section className="py-24 bg-gray-50">
          <div className="max-w-md mx-auto px-6">
            <div className="bg-white border rounded-3xl p-6 hover:shadow-lg transition">
              <h3 className="text-xl font-semibold mb-2">
                ساعات کاری
              </h3>
              <p className="text-gray-600 leading-relaxed">
                شنبه تا چهارشنبه: 9 صبح تا 9 شب<br />
                پنج‌شنبه و جمعه: 10 صبح تا 6 عصر
              </p>
            </div>
          </div>
        </section>

        {/* Social Media */}
        <section className="py-24 border-t">
          <div className="max-w-5xl mx-auto px-6 text-center">
            <span className="inline-block mb-4 px-4 py-1 rounded-full bg-orange-100 text-orange-600 text-sm font-medium">
              شبکه‌های اجتماعی
            </span>

            <h2 className="text-3xl font-bold mb-6">
              بامیزبان را دنبال کنید
            </h2>

            <p className="text-gray-600 mb-10 max-w-2xl mx-auto">
              اخبار و آموزش‌های بامیزبان را در اینستاگرام دنبال کنید.
            </p>

            <a
              href={CONTACT_INFO.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 rounded-2xl border bg-white px-6 py-4
                         text-orange-500 shadow-sm transition
                         hover:bg-orange-500 hover:text-white hover:shadow-lg"
            >
              <FaInstagram size={20} aria-hidden="true" />
              <span dir="ltr" className="font-semibold">@{CONTACT_INFO.instagramHandle}</span>
            </a>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Contact;
